import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const backfillAttendanceSheets = createAsyncThunk<void, { trainingId: string }, { extra: Partial<Dependencies> }>(
  "trainingFollowUps/backfillAttendanceSheets",
  async ({ trainingId }, { extra: { adminRepository } }) => {
    return adminRepository!.backfillAttendanceSheets(trainingId);
  },
);
